import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const TemporaryElement = ({ delay = 3000, children }) => {
  const [showComponent, setShowComponent] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => { setShowComponent(false) }, delay);
    return () => clearTimeout(timer);
  }, [delay, showComponent]);


  return showComponent ? children : null;
};

TemporaryElement.propTypes = {
  delay: PropTypes.number,
  children: PropTypes.node.isRequired,
}

export default TemporaryElement